(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-spotlight"] && !Shopify.designMode) return;
  try {
    
  const spotlightSections = document.querySelectorAll("[data-collection-spotlight]");

  spotlightSections.forEach((section) => {
    const items = Array.from(section.querySelectorAll(".collection-list-spotlight__item"));
    const images = Array.from(section.querySelectorAll(".collection-list-spotlight__image"));
    const hoverCapable = window.matchMedia("(hover: hover) and (pointer: fine)");
    const touchCapable = window.matchMedia("(hover: none) and (pointer: coarse)");
    const isTouch = touchCapable.matches || navigator.maxTouchPoints > 0;

    const setActive = (index) => {
      items.forEach((item) => {
        const isActive = item.dataset.index === index;
        item.classList.toggle("is-active", isActive);
        item.classList.remove("is-armed");
        item.setAttribute("aria-current", isActive ? "true" : "false");
      });

      images.forEach((image) => {
        image.classList.toggle("is-active", image.dataset.index === index);
      });
    };

    items.forEach((item) => {
      const titleLink = item.querySelector(".collection-list-spotlight__title-link");
      const buttonLink = item.querySelector(".collection-list-spotlight__button-link a");

      titleLink.addEventListener("click", (event) => {
        if (isTouch) {
          if (!item.classList.contains("is-active")) {
            event.preventDefault();
            setActive(item.dataset.index);
            item.classList.add("is-armed");
            return;
          }

          if (!item.classList.contains("is-armed")) {
            event.preventDefault();
            item.classList.add("is-armed");
          }
        } else if (!item.classList.contains("is-active")) {
          event.preventDefault();
          setActive(item.dataset.index);
        }
      });

      titleLink.addEventListener("focus", () => setActive(item.dataset.index));
      if (buttonLink) {
        buttonLink.addEventListener("focus", () => setActive(item.dataset.index));
      }
    });

    const handleHover = (event) => {
      const item = event.currentTarget;
      setActive(item.dataset.index);
    };

    const handleHoverState = () => {
      items.forEach((item) => {
        if (hoverCapable.matches) {
          item.addEventListener("mouseenter", handleHover);
        } else {
          item.removeEventListener("mouseenter", handleHover);
        }
      });
    };

    handleHoverState();
    if (hoverCapable.addEventListener) {
      hoverCapable.addEventListener("change", handleHoverState);
    } else if (hoverCapable.addListener) {
      hoverCapable.addListener(handleHoverState);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
